import { useCallback, useMemo } from "react";
import { useDistributionGroups } from "modules/providers/distribution-groups-provider";
import { useTags } from "modules/providers/tags-provider";
import { useUsers } from "modules/providers/users-provider";
import {
  USER_REGEX,
  DISTRIBUTION_GROUP_REGEX,
  TAG_REGEX,
} from "modules/utils/Constants";
import {
  getUserMention,
  getDistributionGroupMention,
  getTagMention,
} from "modules/utils/Functions";

const usePlainText = (text?: string | null) => {
  const { usersById } = useUsers();
  const { tagsById } = useTags();
  const { distributionGroupsById } = useDistributionGroups();

  const getPlainText = useCallback(
    (text?: string | null) => {
      if (!text) return;
      let plainText = text;
      plainText = plainText.replace(USER_REGEX, (_match, userId) => {
        const user = usersById[userId];
        if (user) {
          return getUserMention(user);
        }
        return "";
      });
      plainText = plainText.replace(
        DISTRIBUTION_GROUP_REGEX,
        (_match, distributionGroupId) => {
          const distributionGroup = distributionGroupsById[distributionGroupId];
          if (distributionGroup) {
            return getDistributionGroupMention(distributionGroup);
          }
          return "";
        },
      );
      plainText = plainText.replace(TAG_REGEX, (_match, tagId) => {
        const tag = tagsById[tagId];
        if (tag) {
          return getTagMention(tag);
        }
        return "";
      });
      return plainText;
    },
    [distributionGroupsById, tagsById, usersById],
  );

  const plainText = useMemo(() => getPlainText(text), [getPlainText, text]);

  return {
    getPlainText,
    plainText,
  };
};

export default usePlainText;
